$(function () {
    let event = new Event('form-submit');

    function createRequest(formData, url, type) {
        return $.ajax({
            url: url,
            type: type,
            processData: false,
            contentType: false,
            data: formData
        });
    }

    function showError(element, error) {
        let name = element.prop('name');
        let label = element.siblings('label');

        if (label.length === 0 || label.is(':hidden')) {
            label.remove();
            $(element).after('<label id="'+name+'-error" class="error" for="'+name+'">'+error[0]+'</label>');
        }
    }

    function closeError(element, error) {
        let name = element.prop('name');
        let label = element.siblings('label');
        label.remove();
    }

    let clickSend = false;
    $('#landing-go-form').on('submit', function() {
        if (clickSend) {
            return false;
        }
        clickSend = true;

        let form = $(this);
        let formData = new FormData(form[0]);

        let request = createRequest(
            formData,
            $(form).attr('action'),
            $(form).attr('method')
        ).always(function () {
            clickSend = true;
        });

        request.done(function (result) {
            clickSend = false;
            form.hide();
            $('.form-sent').show();

            if (result.error === false) {
                document.dispatchEvent(event);
            }

            form.find('input,textarea').val('');
            form.find('input[type=checkbox]').prop('checked', false);
        });

        request.fail(function(e) {
            clickSend = false;
            let data = JSON.parse(e.responseText);

            if (data.error === true) {
                let errors = data.content;

                if (typeof errors['first-name'] !== 'undefined') {
                    showError(form.find('input[name=first-name]'), errors['first-name']);
                }

                if (typeof errors['last-name'] !== 'undefined') {
                    showError(form.find('input[name=last-name]'), errors['last-name']);
                }

                if (typeof errors['email'] !== 'undefined') {
                    showError(form.find('input[name=email]'), errors['email']);
                } else {
                    closeError(form.find('input[name=email]'))
                }

                if (typeof errors['phone'] !== 'undefined') {
                    showError(form.find('input[name=phone]'), errors['phone']);
                }

                if (typeof errors['phone'] !== 'undefined') {
                    showError(form.find('input[name=phone]'), errors['phone']);
                }

                if (typeof errors['policy'] !== 'undefined') {
                    showError(form.find('input[name=policy]'), errors['policy']);
                    document.getElementById('submitButton').style.marginTop = '10px';
                }

                if (typeof errors['attached-file'] !== 'undefined') {
                    showError(form.find('input[name=attached-file]'), errors['attached-file']);
                } else {
                    closeError(form.find('input[name=attached-file]'))
                }
            }
        });

        return false;
    });
});
